import { Component, OnInit, Input } from '@angular/core';
import { TerminalActionsSsbtReport } from '../terminal-actions-report.type';
import { AppSettings } from '../../../settings';

@Component({
  selector: '[app-terminal-actions-ssbt-report-partial]',
  templateUrl: './terminal-actions-ssbt-report-partial.component.html',
  styleUrls: ['./terminal-actions-ssbt-report-partial.component.css']
})
export class TerminalActionsSsbtReportPartialComponent implements OnInit {
  readonly calculatedChargeNewStateDefaultRowValue: string = '-';
  @Input() terminalActionsReportPartial: TerminalActionsSsbtReport;
  @Input() terminalActionTypes: any[];

  currencySuffix: string;
  constructor(
    private _settings: AppSettings,
  ) {
    this.currencySuffix = this._settings.getCurrencySuffix(new Date());
  }

  ngOnInit() {
    this.currencySuffix = this._settings.getCurrencySuffix(new Date(this.terminalActionsReportPartial.date));
  }

  private getTerminalActionTypeName(terminalActionTypeId: number) {
    if (terminalActionTypeId != null && this.terminalActionTypes != null) {
      const terminalAction = this.terminalActionTypes.find(actionType => actionType.id === terminalActionTypeId);
      if (terminalAction != null)
        return terminalAction.name;
    }
    return '';
  }

  private getCalculatedChargeNewStateDefaultRowValue() {
    return this.calculatedChargeNewStateDefaultRowValue;
  }
}



// WEBPACK FOOTER //
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-actions-ssbt-report/terminal-actions-ssbt-report-partial/terminal-actions-ssbt-report-partial.component.ts